@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

@spaceMedium: @space-16;

.shopper-tasks {
  display: flex;
  flex-direction: column;
  gap: @spaceMedium 0;
  margin-top: @spaceMedium;
}
